<template>
  <div class="room-details">
    <h1>Room details</h1>
  </div>
</template>

<script>
import BookingRoomPagesMixin from '@mixins/booking-room-pages'

export default {
  name: 'room-details',
  mixins: [BookingRoomPagesMixin]
}
</script>